import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** Permette alla Notification API e ad altri listener di navigare in SPA verso /messaggi. */
export function StaffSocketBridge() {
  const navigate = useNavigate();
  useEffect(() => {
    const onNav = (e: Event) => {
      const d = (e as CustomEvent<{ conversationId: string }>).detail;
      if (d?.conversationId) navigate(`/messaggi?conversationId=${encodeURIComponent(d.conversationId)}`);
    };
    window.addEventListener('staff-messaging:navigate', onNav as EventListener);
    return () => window.removeEventListener('staff-messaging:navigate', onNav as EventListener);
  }, [navigate]);
  return null;
}
